<template>
  <a-modal v-model="mobilePhoneCheckModal"
           title="验证"
           :footer="null"
           :keyboard="false"
           :maskClosable="false"
           @cancel="handleCancel">
    <div class="login">
      <a-form :form="form"
              @submit="onSubmit">
        <a-form-item>
          <a-input size="large"
                   placeholder="手机号码"
                   disabled
                   v-decorator="['mobile', {rules: [{ required: true, message: '请输入手机号', whitespace: true}]}]">
            <a-icon slot="prefix"
                    type="mobile"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-row :gutter="8">
            <a-col :span="16">
              <a-input size="large"
                       placeholder="验证码"
                       v-decorator="['code', {rules: [{ required: true,message: '请输入验证码', whitespace: true}]}]">
                <a-icon slot="prefix"
                        type="mail"/>
              </a-input>
            </a-col>
            <a-col :span="8">
              <a-button @click="requestCode()"
                        :disabled="disabled"
                        :class="btnText==='获取验证码' ? 'buggetyaz' : 'getyaz'"
                        class="captcha-button"
                        size="large">{{ btnText }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item>
          <a-checkbox-group
              v-decorator="['checked', {initialValue:[],rules: [{ required: true,message: '请选择已阅读并同意评审专家履职承诺书'}]}]">
            <a-checkbox value="1">我已阅读并同意</a-checkbox>
            <a @click="openCommitment">评审专家履职承诺书</a>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item>
          <a-button :loading="submitLoading"
                    style="width: 100%"
                    size="large"
                    htmlType="submit"
                    type="primary">提交审核
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <expert-apply-for-commitment-modal @handleAgree="handleAgree" ref="commitmentRef"/>
  </a-modal>
</template>

<script>
import { GetVerificationCode } from '@/views/login/api/LoginApi'
import ExpertApplyForCommitmentModal from '@/epp/expertmain/expertInfo/common/ExpertApplyForCommitmentModal.vue'

export default {
  name: 'MobilePhoneCheckModal',
  components: { ExpertApplyForCommitmentModal },
  data () {
    return {
      mobilePhoneCheckModal: false,
      submitLoading: false,
      form: this.$form.createForm(this),
      btnText: '获取验证码',
      disabled: false,
    }
  },
  methods: {
    handleAgree () {
      this.form.setFieldsValue({
        checked: ['1']
      })
    },
    openCommitment () {
      this.$refs.commitmentRef.init()
    },
    init (mobilePhone) {
      this.mobilePhoneCheckModal = true
      this.submitLoading = false
      this.$nextTick(() => {
        this.form.setFieldsValue({
          mobile: mobilePhone
        })
      })
    },
    async requestCode () {
      let mobile = this.form.getFieldValue('mobile')
      if (!mobile) {
        this.$warning({
          title: '请输入手机号！'
        })
        return
      }
      const that = this
      this.disabled = true
      this.btnText = '请稍候...'
      this.type = 'gray'
      try {
        let res = await GetVerificationCode(mobile)
        if (res.code !== 200) {
          that.$error({ content: res.msg })
          that.btnText = '获取验证码'
          that.disabled = false
          that.type = 'primary'
          return
        }
        that.$message.success(res.msg)
        setTimeout(() => {
          let seconds = 60
          that.btnText = seconds + 's后获取'
          let countdown = setInterval(() => {
            if (seconds > 0) {
              that.btnText = seconds + 's后获取'
              --seconds
            } else {
              that.btnText = '获取验证码'
              that.disabled = false
              that.type = 'primary'
              clearInterval(countdown)
            }
          }, 1000)
        }, 500)
      } catch (e) {
        that.$message.error(e.message)
      }
    },
    onSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.submitLoading = true
        this.$emit('sumitSuccess', values.code)
      })
    },
    handleCancel (e) {
      e.preventDefault()
      if (this.submitLoading) {
        this.$message.warning('正在提交中，请稍后...')
        return
      } else {
        this.mobilePhoneCheckModal = false
      }
    },
    success () {
      this.submitLoading = false
      this.mobilePhoneCheckModal = false
    },
  },

}
</script>

<style lang="less" scoped>
.login {
  margin-top: 20px;

  .icon {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    margin-left: 16px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }
  }
}
</style>
